<template>
  <div class="contact-us full-screen">
    <TopNavbar />
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 container-404">
              <div class="error-box">
                <p>Error</p>
                <h2 class="title text-danger not-found-title">404 </h2>
                <p>Page Not Found</p>
              </div>
              <div class="info">
                <h3>We have encountered an error</h3>
                <ul>
                  <li v-if="error">
                   <div class="info-value">{{ error }}</div>
                  </li>
                  <li v-if="page">
                    <label>Last page: </label><div class="info-value">{{ page }}</div>
                  </li>
                  <li>
                    <label>IP: </label><div class="info-value">{{ userInfo.ip }}</div>
                  </li>
                  <li>
                    <label>Browser used: </label><div class="info-value">{{ userInfo.browser }}</div>
                  </li>
                  <li>
                    <label>Mobile: </label><div class="info-value">{{userInfo.isPhone ? 'Yes' : 'No'}}</div>
                  </li>
                  <li>
                    <label>Operating System: </label><div class="info-value">{{userInfo.os}}</div>
                  </li>
                </ul>
              </div>
              <router-link :to="{path:'/'}">Go Back Home</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from '../Dashboard/Layout/TopNavbar'
import {PatientInfoUtils} from '../../utils/PatientInfo'
export default {
  data () {
    return {
      userInfo: {},
      error: '',
      page: ''
    }
  },
  components: {
    TopNavbar
  },
  mixins: [PatientInfoUtils],
  async beforeMount () {
    if (this.$route.query.error) {
      let error = this.$route.query.error.replace('_', ' ')
      error = error.charAt(0).toUpperCase() + error.slice(1)
      this.error = error + ' page is not enabled right now.'
    }
    if (this.$route.query.page) {
      this.page = window.location.origin + this.$route.query.page
    }
    this.userInfo = await this.getPatientInfo()
  }
}

</script>
<style lang="scss" scoped>
.contact-us{
  background: #ffffff;
}
.container-404{
  background: #f8f8f8;
  border-radius: 5px;
  border: 1px solid #e7e6e6;
  margin-top: 100px;
  .error-box{
    width: fit-content;
    padding:15px 8px;
    border:1px solid black;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 50px auto 40px;
    p:nth-of-type(1) {
      position: relative;
      color: #509119;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      margin:0;
      &::after{
        content: '';
        position: absolute;
        top: 8px;
        left: -10px;
        background: #509119;
        border-radius: 50%;
        width: 5px;
        height: 5px;
      }
      &::before{
        content: '';
        position: absolute;
        top: 8px;
        right: -10px;
        background: #509119;
        border-radius: 50%;
        width: 5px;
        height: 5px;
      }
    }
    p:nth-of-type(2) {
      position: relative;
      color: #509119;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      letter-spacing: -0.5px;
    }
    .not-found-title{
      position: relative;
      color: #595959;
      font-size: 60px;
      font-weight: 600;
      font-family: sans-serif, Verdana;
      letter-spacing: 1.5px;
      margin-top:0;
      margin-bottom: 10px;
      &::after{
        content: '';
        position: absolute;
        width: 95%;
        height: 2px;
        background: #abaaaa;
        bottom: 0;
        left:2px;
      }
    }
  }
  .info{
    position: relative;
    display:flex;
    flex-direction: column;
    width: 50%;
    margin:0 auto 50px;
    height: fit-content;
    padding:10px 0;
    border-radius: 20px;
    color: #1f1e1e;
    h3{
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 15px;
      letter-spacing: -0.5px;
      color: #509119;
    }
    ul{
      list-style-type: none;
      padding: 0;
      li{
        display:flex;
        align-items: start;
        flex-direction: row;
        margin-bottom: 0px;
        label{
          font-size: 13px;
          font-weight: 500;
          font-family: 'Muli', Arial, sans-serif;
          margin-bottom: 0;
          text-align: right;
          margin-right: 5px;
          color: #888787;
        }
        .info-value{
          font-size: 13px;
          font-weight: 500;
          margin-left:0px;
          text-align: left;
          color:gray;
        }
      }
    }
  }
  a{
    display: block;
    width: fit-content;
    margin:30px auto;
    font-size: 17px;
    padding:7px 20px;
    color:black;
    background: #d2d2d2;
    text-align: center;
    border-radius: 5px;
    transition: 0.4s;
    &:hover{
      background: #afafaf;
    }
  }
}

@media only screen and (max-width: 600px) {
  .container-404{
    width: 90%;
    margin:80px auto 0;
    .info{
      width: 95%;
      margin:0 auto;
      h3{
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralViews/NotFoundPage.vue